var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D47700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 4.80005C9.78364 4.80005 7.98062 6.60304 7.98062 8.81964C7.98062 9.42407 8.47073 9.91424 9.07521 9.91424C9.67958 9.91424 10.1697 9.42407 10.1697 8.81964C10.1697 7.81043 10.9906 6.98917 11.9998 6.98917C13.0089 6.98917 13.8298 7.81043 13.8298 8.81964C13.8298 9.82889 13.0089 10.6497 11.9998 10.6497C11.3953 10.6497 10.9052 11.1398 10.9052 11.7442V14.215C10.9052 14.8194 11.3953 15.3095 11.9998 15.3095C12.6042 15.3095 13.0943 14.8194 13.0943 14.215V12.6872C14.7802 12.2097 16.0189 10.6566 16.0189 8.81961C16.019 6.60304 14.2159 4.80005 11.9998 4.80005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 16.1379C11.1542 16.1379 10.4686 16.8235 10.4686 17.6695C10.4686 18.5146 11.1542 19.2001 11.9998 19.2001C12.8453 19.2001 13.5309 18.5145 13.5309 17.6695C13.5309 16.8235 12.8453 16.1379 11.9998 16.1379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.abc23e39435b14c19735ed5d63628263.svg";
export { ForwardRef as ReactComponent };